module.exports = __webpack_public_path__ + "img/8dc93e714751acbd21b1e3cfd9af1bfc.png";